export default "__VITE_ASSET__BpuoE5IH__"